// extracted by mini-css-extract-plugin
export default {"companyName":"companyList_companyName__zvbhn"};